// Use lower case inside key! also used to specify accepted files to upload.
// .doc .docx
const WORD_MYME_TYPES = [
  'application/x-cfb',
  'application/msword',
  'application/doc',
  'application/ms-doc',
  'application/vnd.ms-word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'odt', // upps drag and drop will not allow .odt otherwise
];
// .xls .xlsx
const EXCEL_MYME_TYPES = [
  'application/excel',
  'application/msexcel',
  'application/x-excel',
  'application/x-msexcel',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet',
  '.ods', // upps drag and drop will not allow .ods otherwise
];
// .ppt .pps .pptx
const POWER_POINT_MYME_TYPES = [
  'application/mspowerpoint',
  'application/powerpoint',
  'application/vnd.ms-powerpoint',
  'application/x-mspowerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  '.odp', // upps drag and drop will not allow .odp otherwise
];
// .zip
const ZIP_MYME_TYPES = ['application/zip', 'application/x-zip-compressed'];
// .rtf
const RTF_MYME_TYPES = ['application/rtf', 'application/x-rtf', 'text/richtext', 'text/rtf'];
const DICOM_MYME_TYPES = [
  '.dcm', // uppy's drag and drop will not allow .dcm files otherwise
  'application/dicom',
];
const WEBM_MYME_TYPES = ['video/webm', 'audio/webm'];
const MP4_MYME_TYPES = ['video/mp4', 'audio/mp4', 'audio/x-m4a'];

const PDF_MYME_TYPE = 'application/pdf';
const JPEG_MYME_TYPE = 'image/jpeg';
const PNG_MYME_TYPE = 'image/png';
const TIFF_MYME_TYPE = 'image/tiff';
const MOV_MYME_TYPE = 'video/quicktime';
const OGG_MYME_TYPE = 'audio/ogg';
const MP3_MYME_TYPE = 'audio/mpeg';
const CSV_MYME_TYPE = 'text/csv';
const MD_MYME_TYPE = 'text/markdown';
const TXT_MYME_TYPE = 'text/plain';

export const MIME_TYPE_TO_DISPLAY_NAME = {
  ...DICOM_MYME_TYPES.reduce((prev, curr) => ({ ...prev, [curr]: 'DICOM' }), {}),
  ...WEBM_MYME_TYPES.reduce((prev, curr) => ({ ...prev, [curr]: 'WEBM' }), {}),
  ...MP4_MYME_TYPES.reduce((prev, curr) => ({ ...prev, [curr]: 'MP4' }), {}),
  ...EXCEL_MYME_TYPES.reduce((prev, curr) => ({ ...prev, [curr]: 'Excel' }), {}),
  ...POWER_POINT_MYME_TYPES.reduce((prev, curr) => ({ ...prev, [curr]: 'PowerPoint' }), {}),
  ...WORD_MYME_TYPES.reduce((prev, curr) => ({ ...prev, [curr]: 'Word' }), {}),
  ...ZIP_MYME_TYPES.reduce((prev, curr) => ({ ...prev, [curr]: 'Zip' }), {}),
  ...RTF_MYME_TYPES.reduce((prev, curr) => ({ ...prev, [curr]: 'RTF' }), {}),
  [PDF_MYME_TYPE]: 'PDF',
  [JPEG_MYME_TYPE]: 'JPEG',
  [PNG_MYME_TYPE]: 'PNG',
  [TIFF_MYME_TYPE]: 'TIFF',
  [MOV_MYME_TYPE]: 'mov',
  [OGG_MYME_TYPE]: 'ogg',
  [MP3_MYME_TYPE]: 'MP3',
  [CSV_MYME_TYPE]: 'csv',
  [MD_MYME_TYPE]: 'md',
  [TXT_MYME_TYPE]: 'txt',
};

export const AUDIO_MESSAGE_PREFIX = 'AM';
export const AUDIO_MESSAGE_MAX_DURATION = 120000;

export const ALLOWED_MIME_TYPES = Object.keys(MIME_TYPE_TO_DISPLAY_NAME);
export const ALLOWED_INVITATION_FILE_MIME_TYPES = [
  ...WORD_MYME_TYPES,
  ...EXCEL_MYME_TYPES,
  PDF_MYME_TYPE,
];

export const STAFF_TYPES = {
  PHYSICIAN: 'physician',
  ASSISTANT: 'assistant',
};

export const CHAT_MESSAGE_TYPE = {
  PAM_REQUEST: 'PAM_REQUEST',
  SESSION_CALL: 'session__call',
  SESSION_MEETING: 'session__meeting',
  SESSION_MESSAGES: 'session-messages',
  SUPPORT_WELCOME_MESSAGE: 'supportWelcomeMessage',
  SYSTEM: 'system',
};

// Copied from packages/backend/pam-service/app/services/wsService.js -> shared file?
export const PAM_WEBSOCKET_EVENTS = {
  REQUEST_CREATED: 'pam:request_created',
  REQUEST_UPDATED: 'pam:request_updated',
  REQUESTS_UPDATED: 'pam:requests_updated',
  REQUEST_DELETED: 'pam:request_deleted',
  NOTE_CREATED: 'pam:note_created',
  NOTE_DELETED: 'pam:note_deleted',
  NOTE_UPDATED: 'pam:note_updated',
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  PAGES_MODIFIED: 'PAGES_MODIFIED',
};

export const PARTICIPANT_ROLES = {
  MODERATOR: 'moderator',
  ORGANIZER: 'organizer',
};

export const SESSION_TYPES = {
  MEETING: 'meeting', // "Videotermin"
  CHAT: 'chat', // group chat
  CALL: 'call', // instant call - "Jetzt per Video anrufen"
  INTERNAL1ON1: 'internal1on1', // "Mitarbeiter-zu-Mitarbeiter"-Chat
  TEAM_CHAT: 'teamChat', // physician-and-all-his-staff group chat
  PAM_CHAT: 'pmChat', // PAM chat
};

export const USER_TYPES = {
  PATIENT: 'patient',
  PHYSICIAN: 'physician',
  STAFF: 'staff',
};

export const DATE_INPUT = {
  MAX: '2049-12-31T23:59',
};

export const CLIENT_TYPES = {
  PATIENT: 'patient',
  PHYSICIAN: 'physician',
  STAFF: 'staff',
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  CHAT: 'chat',
};

export const WEEKDAYS = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
};

export const ID_PREFIXES = {
  PHYSICIAN: 'med-',
  STAFF: 'stf-',
  PATIENT: 'pat-',
  SUB_PATIENT: 'pat-sub-',
};

export const CHAT_DELETION_INTERVALS = {
  TEMPORARY: 50,
  DEFAULT: 105,
};

export const ALLOWED_AUDIO_RECORDING_URLS = [
  's3.fes.cloud.syseleven.net',
  'storage-gw-de-01.voximplant.com',
];
